var _style, _path, _path2, _path3, _path4, _rect, _path5, _path6, _rect2, _rect3, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecoil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2546.8 901.7",
    style: {
      enableBackground: "new 0 0 2546.8 901.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C1E21;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,393c6.7-1.4,13.6-2.4,20.5-3l0,0l0,0l53.6-5.1l-72.8-79.8c-21.9-24.1-34-55.3-34-87.9H4.4 c0,47.6,17.7,93.3,49.8,128.5L97.3,393z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.3,509.9c-5.4,1-10.9,1.7-16.4,2.3l0,0l0,0l-58,5.5l72.6,79.6c21.9,24.1,34,55.3,34,87.9h60.3 c0-47.6-17.7-93.2-49.8-128.5L285.3,509.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385,333c-9.9-49.2-48.5-85-98.3-91.3l-9.2-1.2c-31.1-3.9-54.6-30.5-54.6-61.8v-32.1c27.6-11.5,47-38.7,47-70.4 c0-42.1-34.1-76.2-76.2-76.2s-76.2,34.1-76.2,76.2c0,31,18.6,57.7,45.2,69.6v32.9c0,61.7,46.1,114,107.3,121.6l9.2,1.2 c28.7,3.6,43,24.8,46.8,43.4c3.8,18.6-1.1,43.7-26.2,58.2c-12.3,7.1-25.6,11.4-39.7,12.7l-138.3,13c-22.8,2.2-44.4,9.1-64.2,20.5 C14.1,474.5-7.6,522.5,2.4,571.7c9.9,49.2,48.5,85,98.3,91.3l9.2,1.2c31.1,3.9,54.6,30.5,54.6,61.8v29.2 c-27.5,11.5-46.8,38.7-46.8,70.3c0,42.1,34.1,76.2,76.2,76.2s76.2-34.1,76.2-76.2c0-31.1-18.7-57.9-45.4-69.7v-29.8 c0-61.7-46.1-114-107.3-121.6l-9.2-1.2c-28.7-3.6-43-24.8-46.8-43.4c-3.8-18.6,1.1-43.7,26.2-58.2c12.3-7.1,25.6-11.4,39.7-12.7 l138.3-13c22.8-2.2,44.4-9.1,64.2-20.5C373.3,430.2,394.9,382.2,385,333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1426.6,675H1224c-69.8,0-126.6-56.8-126.6-126.6V362.8c0-69.8,56.8-126.6,126.6-126.6h108.3 c69.8,0,126.6,56.8,126.6,126.6v29.2c0,53.7-43.7,97.4-97.4,97.4h-206.1v59.1c0,37.8,30.8,68.6,68.6,68.6h202.5V675z M1155.5,431.4 h206.1c21.7,0,39.4-17.7,39.4-39.4v-29.2c0-37.8-30.8-68.6-68.6-68.6H1224c-37.8,0-68.6,30.8-68.6,68.6V431.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2363.4,
    y: 272.7,
    className: "st0",
    width: 58,
    height: 395.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2171.5,675h-108.3c-69.8,0-126.6-56.8-126.6-126.6V362.8c0-69.8,56.8-126.6,126.6-126.6h108.3 c69.8,0,126.6,56.8,126.6,126.6v185.7C2298,618.3,2241.3,675,2171.5,675z M2063.2,294.2c-37.8,0-68.6,30.8-68.6,68.6v185.7 c0,37.8,30.8,68.6,68.6,68.6h108.3c37.8,0,68.6-30.8,68.6-68.6V362.8c0-37.8-30.8-68.6-68.6-68.6H2063.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1965.6,460.3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2488.9,
    y: 146.9,
    className: "st0",
    width: 58,
    height: 521.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2363.4,
    y: 148.8,
    className: "st0",
    width: 58,
    height: 54.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1747.3,679.8H1639c-69.8,0-126.6-56.8-126.6-126.6V367.5c0-69.8,56.8-126.6,126.6-126.6h108.3 c69.8,0,126.6,56.8,126.6,126.6v29h-58v-29c0-37.8-30.8-68.6-68.6-68.6H1639c-37.8,0-68.6,30.8-68.6,68.6v185.7 c0,37.8,30.8,68.6,68.6,68.6h108.3c37.8,0,68.6-30.8,68.6-68.6v-29h58v29C1873.9,623,1817.1,679.8,1747.3,679.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1541.4,465.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1011.7,685.1h-58v-20c0-34.6-13.1-67.7-37-93.3l-0.8-0.8l-54.8-69.1l45.5-36l53.3,67.3 c33.4,36.2,51.7,83.1,51.7,131.9V685.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M710.4,685.1l-58-0.2l1.1-369.4c0.1-42.4,35.1-76.8,78.1-76.8l0.3,0c28.7,0.3,56.5-0.2,83.5-0.6 c27.3-0.4,55.5-0.9,85-0.6c19.3,0.2,56,4.9,85.6,34.2c19.5,19.2,31.6,46.2,34.3,76c2.5,28.4-3.7,56.6-17.6,79.4 c-23.9,39.5-63.7,53.1-79.7,57.1l-41.4,10.5c-32.1,7.8-63.4,15.7-93.6,23.3c-25,6.3-50.6,12.8-77,19.3L710.4,685.1z M731.5,296.7 c-11,0.1-19.9,8.6-20,19L711,477.5c21.3-5.3,42.2-10.6,62.6-15.7c30.3-7.7,61.7-15.6,94-23.4l41.1-10.4c9-2.2,31.4-9.8,44.2-30.9 c15.7-25.9,12.1-64.4-7.9-84.2c-15.6-15.4-36.9-17.3-45.4-17.4c-28.6-0.3-56.5,0.2-83.4,0.6C789,296.5,760.8,297,731.5,296.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoil);
export default __webpack_public_path__ + "static/media/Recoil.431f0ae1f6c31cd5f4c2af38d83363b1.svg";
export { ForwardRef as ReactComponent };